/**
 * for http status code: 401
 */
export class UnauthorizedError extends Error {
  /**
   * Create an UnauthorizedError
   * @param {String} message
   */
  constructor(message) {
    super(message);
    this.name = 'UnauthorizedError';
  }
}
